module.exports = __webpack_public_path__ + "static/media/appetizer-short.2ab83274.svg";